module.exports = __webpack_public_path__ + "static/media/pubmed-small.82db5210.svg";